import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";


export function TrackingOptionModal({open, setOpen, onComplete, trackingOptions, onTrackingOptionChange, partOrder}) {
    // Add tracking option to data sent to complete view
    const onCompleteClick = () => {
        //check if correct field has been entered
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            closeOnBlur
            onClose={() => {
                setOpen(false)
            }}
            active={open}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Add Tracking Category to Invoice</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <TrackingOptionsPicker
                                name={"tracking_option"}
                                onChange={onTrackingOptionChange}
                                value={partOrder.tracking_option}
                                label={"Tracking Option"}
                                inlineEdit={false}
                                editable={true}
                                options={trackingOptions}
                                blank={true}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={() => {
                                    onComplete();
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Complete
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );


}